export class Accreditation {
  private readonly docsUrl = '/assets/docs';
  private readonly thumbnailsUrl = '/assets/img/acreditaciones';

  name: string;
  hasBranchOffice: boolean
  viewTitle?: string;
  quantity?: string;

  constructor(name: string, hasBranchOffice: boolean, quantity?: string, viewTitle?: string) {
    this.name = name;
    this.viewTitle = viewTitle;
    this.quantity = quantity;
    this.hasBranchOffice = hasBranchOffice;
  }

  get mainUrl() { return `${this.docsUrl}/${this.name}.pdf`; }

  get branchOfficeUrl() { return `${this.docsUrl}/${this.name}-S1.pdf`; }

  get mainTableUrl() { return `${this.docsUrl}/TABLA_${this.name}.pdf`; }

  get branchOfficeTableUrl() { return `${this.docsUrl}/TABLA_${this.name}-S1.pdf`; }

  get mainViewTitle() { return this.viewTitle ? this.viewTitle : `${this.quantity} ${this.name}`; }

  get branchOfficeViewTitle() { return this.viewTitle ? this.viewTitle : `${this.quantity} ${this.name} S1`; }

  get mainThumbnailUrl() { return `${this.thumbnailsUrl}/${this.name}.png`; }

  get branchOfficeThumbnailUrl() { return `${this.thumbnailsUrl}/${this.name}-S1.png`; }
}
